
import {
    GET_AFF_TRIALS_REQUEST,
    GET_AFF_TRIALS_RESPONSE,
    GET_AFF_TRIALS_FAILURE,
} from '../../actions/types';

const initialState = {
    keyword: '',
    isFetching: false,
    sites: [],
    country: 'All',
    statusCode: 0,
    error: false,
    isInitalScreen: true,
};

const setFetching = (state, action) => {
    return {
        ...state,
        isFetching: true,
        results: [],
        statusCode: 0,
        keyword: action.payload.keyword,
        country: action.payload.country,
        isInitalScreen: false,

    }
}

const setFailure = (state, action) => {
    return {
        ...state,
        isFetching: false,
        error: true,
        sites: [],
    }
}

const setResults = (state, action) => {

    let sites = action.payload.sites || [];
    let statusCode = action.payload.statusCode;
    let country = action.payload.country;



    return {
        ...state,
        isFetching: false,
        error: false,
        sites,
        country,
        statusCode
    }

}


export default (state = initialState, action) => {
    switch (action.type) {
        case GET_AFF_TRIALS_REQUEST:
            return setFetching(state, action);
            break;

        case GET_AFF_TRIALS_RESPONSE:
            return setResults(state, action);

        case GET_AFF_TRIALS_FAILURE:
            return setFailure(state, action);

        default:
            return state;
            break;
    }
}